__turbopack_context__.v({
  "closeButton": "CheckoutOutOfStockForm-module-scss-module__anc-Uq__closeButton",
  "inCartDrawer": "CheckoutOutOfStockForm-module-scss-module__anc-Uq__inCartDrawer",
  "itemsWrapper": "CheckoutOutOfStockForm-module-scss-module__anc-Uq__itemsWrapper",
  "separator": "CheckoutOutOfStockForm-module-scss-module__anc-Uq__separator",
  "titleRow": "CheckoutOutOfStockForm-module-scss-module__anc-Uq__titleRow",
});
